export default __webpack_public_path__ + "static/media/Avatar-9.9271957c.png";